import { BookingServiceItem } from "@okeys/shared-utils"

export type CollectionTotals = {
  totalServicesPrice: number
  totalPromotionDiscount: number
  totalPrice: number
  appliedPromotionCount: number
}

export const calculateCollectionTotals = (
  services: BookingServiceItem[]
): CollectionTotals => {
  let totalServicesPrice = 0
  let totalPromotionDiscount = 0
  const promotionIds = new Set<string>()

  services.forEach((service) => {
    if (!service.cancelled) {
      const oldPrice = service.price
      const newPrice = service.discountApplied
        ? service.discountApplied.priceEffect.newPrice
        : oldPrice
      const discount = oldPrice - newPrice

      totalServicesPrice += oldPrice
      totalPromotionDiscount += discount

      if (service.discountApplied && "promotionId" in service.discountApplied) {
        promotionIds.add(service.discountApplied.promotionId)
      }
    }
  })

  const totalPrice = totalServicesPrice - totalPromotionDiscount
  const appliedPromotionCount = promotionIds.size

  return {
    totalServicesPrice,
    totalPromotionDiscount,
    totalPrice,
    appliedPromotionCount,
  }
}
